export default "__VITE_ASSET__vWGbm1wP__"